module.exports = __webpack_public_path__ + "static/media/1POLICY9.db61c63a.jpg";